import { useEffect, useState } from "react";

/**
 * @param {Object} baseSizes - Ex: { title: 32, subtitle: 24, button: 18 }
 * @returns {Object} - Os tamanhos ajustados responsivamente
 */
export const useResponsiveText = (baseSizes = {}) => {
  const [textSizes, setTextSizes] = useState(baseSizes);

  useEffect(() => {
    const calculateTextSizes = () => {
      const windowHeight = window.innerHeight;
      
      let scale = 1;
      if (windowHeight <= 600) scale = 0.7;
      else if (windowHeight <= 800) scale = 0.8;
      else if (windowHeight <= 1000) scale = 0.9;
      else scale = 1;

      const responsiveSizes = {};
      Object.entries(baseSizes).forEach(([key, value]) => {
        responsiveSizes[key] = Math.round(value * scale);
      });
      setTextSizes(responsiveSizes);
    };

    calculateTextSizes();
    window.addEventListener('resize', calculateTextSizes);
    window.addEventListener('orientationchange', calculateTextSizes);

    return () => {
      window.removeEventListener('resize', calculateTextSizes);
      window.removeEventListener('orientationchange', calculateTextSizes);
    };
  }, []);

  return textSizes;
};